import { Layout, Menu, type MenuProps } from 'antd'
import { Content, Header } from 'antd/lib/layout/layout'
import { ProductOutlined } from '@ant-design/icons';
import { Outlet, useLocation, useNavigation } from 'react-router-dom';
import { topLevelRouter } from '../routing/router';
import { useUserStore } from '../state/user_state';
import ShellActionButtons from './shell_action_buttons';
import { Suspense } from 'react';
import LoaderComponent from 'shared-lib/components/loader.js';
import { cn } from '@/lib/utils';

const items: MenuProps['items'] = [
    {
        key: "",
        label: 'Alle Vorgänge',
        icon: <ProductOutlined style={{ fontSize: 20, transform: 'translateY(1px)' }} />,
        onClick: () => {
            topLevelRouter.navigate('/', { viewTransition: true });
        },
    },
]

export default function AppShell() {

    const location = useLocation();
    const user = useUserStore();
    const navigation = useNavigation();

    const isNavigating = navigation.state === 'loading';

    return (
        <Layout style={{ minHeight: '100vh', minWidth: '100vw', backgroundColor: 'transparent' }}>
            <Header
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 25,
                    paddingRight: 25,
                    borderBottom: '1px solid rgba(255, 255, 255, 0.18)',
                    position: "fixed",
                    left: 0,
                    top: 0,
                    right: 0,
                    zIndex: 1000,
                }}
            >
                {/* Navigation loading indicator */}
                <div className="absolute top-0 left-0 right-0 h-0.5 overflow-hidden">
                    <div
                        className={cn(
                            "h-full transition-transform duration-300 ease-out",
                            isNavigating
                                ? "animate-[loading-bar_1.5s_ease-in-out_infinite]"
                                : "-translate-x-full"
                        )}
                        style={{ backgroundColor: "#ffa200" }}
                    />
                </div>
                <div style={{ width: 174, display: 'flex', alignItems: 'center' }}>
                    <img src='/assets/logo_full.png' width={125} />
                </div>
                {
                    // Do not render menu for one time token users as they cant access any other pages
                    user.user!.tokenType === 'account' ?
                        <Menu
                            theme="dark"
                            mode="horizontal"
                            items={items}
                            style={{
                                flex: 1,
                                minWidth: 0,
                                backgroundColor: 'transparent'
                            }}
                            selectedKeys={[location.pathname.split("/")[1]]}
                            styles={
                                {
                                    item: { borderRadius: 8, maxHeight: "40px", display: "flex", alignItems: "center", "justifyContent": "center" }
                                }
                            }
                        /> :
                        <div className='flex flex-1' />
                }
                <ShellActionButtons />
            </Header>
            <Content
                style={{
                    marginTop: 63,
                    minHeight: "calc(100vh - 63px)",
                }}
            >
                <Suspense fallback={<LoaderComponent />}>
                    <Outlet />
                </Suspense>
            </Content>
        </Layout>
    )
}